// MONTKUSH customer-story cards: poster-first video lightbox with native controls.
(() => {
  const focusableSelector = 'button:not([disabled]), [href], video[controls]';

  const makeLightbox = () => {
    const dialog = document.createElement('dialog');
    dialog.className = 'mk-testimonial-lightbox';
    dialog.setAttribute('aria-modal', 'true');
    dialog.setAttribute('aria-label', 'Customer story video');
    dialog.innerHTML = `
      <div class="mk-testimonial-lightbox__stage">
        <button class="mk-testimonial-lightbox__close" type="button" aria-label="Close video">×</button>
        <div class="mk-testimonial-lightbox__mount"></div>
      </div>`;
    document.body.appendChild(dialog);
    return dialog;
  };

  const initialiseDeferredVideos = () => {
    const sections = [...document.querySelectorAll('.mk-testimonials')];
    if (!sections.length) return;

    const dialog = document.querySelector('.mk-testimonial-lightbox') || makeLightbox();
    const closeButton = dialog.querySelector('.mk-testimonial-lightbox__close');
    const mount = dialog.querySelector('.mk-testimonial-lightbox__mount');
    let activeTrigger = null;
    let fallbackOpen = false;

    const clearVideo = () => {
      const video = mount.querySelector('video');
      if (video) {
        video.pause();
        video.removeAttribute('src');
        video.load();
        video.remove();
      }
    };

    const restoreFocus = () => {
      const trigger = activeTrigger;
      activeTrigger = null;
      if (trigger && document.contains(trigger)) trigger.focus({ preventScroll: true });
    };

    const closeLightbox = () => {
      if (typeof dialog.close === 'function' && dialog.open) {
        dialog.close();
        return;
      }
      fallbackOpen = false;
      dialog.removeAttribute('open');
      document.documentElement.classList.remove('mk-testimonial-lightbox-open');
      clearVideo();
      restoreFocus();
    };

    const openLightbox = (trigger, wrapper) => {
      const source = wrapper.dataset.videoSrc;
      if (!source) return;
      activeTrigger = trigger;
      clearVideo();

      const video = document.createElement('video');
      video.className = 'mk-testimonial-lightbox__video';
      video.controls = true;
      video.playsInline = true;
      video.preload = 'metadata';
      video.src = source;
      video.poster = wrapper.dataset.videoPoster || '';
      video.loop = wrapper.dataset.videoLoop === 'true';
      video.setAttribute('aria-label', wrapper.dataset.videoTitle || trigger.getAttribute('aria-label') || 'Customer story video');
      video.addEventListener('error', closeLightbox, { once: true });
      mount.appendChild(video);

      if (typeof dialog.showModal === 'function') {
        if (!dialog.open) dialog.showModal();
      } else {
        fallbackOpen = true;
        dialog.setAttribute('open', '');
        document.documentElement.classList.add('mk-testimonial-lightbox-open');
      }
      closeButton.focus({ preventScroll: true });
      video.play().catch(() => {});
    };

    dialog.addEventListener('close', () => {
      fallbackOpen = false;
      document.documentElement.classList.remove('mk-testimonial-lightbox-open');
      clearVideo();
      restoreFocus();
    });

    dialog.addEventListener('cancel', (event) => {
      if (fallbackOpen) {
        event.preventDefault();
        closeLightbox();
      }
    });

    dialog.addEventListener('click', (event) => {
      if (event.target === dialog || event.target.closest('.mk-testimonial-lightbox__close')) closeLightbox();
    });

    dialog.addEventListener('keydown', (event) => {
      if (event.key === 'Escape' && fallbackOpen) {
        event.preventDefault();
        closeLightbox();
        return;
      }
      if (event.key !== 'Tab' || !fallbackOpen) return;
      const focusable = [...dialog.querySelectorAll(focusableSelector)].filter((element) => !element.hidden);
      if (!focusable.length) return;
      const first = focusable[0];
      const last = focusable[focusable.length - 1];
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });

    sections.forEach((section) => {
      if (section.dataset.deferredVideoReady === 'true') return;
      section.dataset.deferredVideoReady = 'true';
      section.addEventListener('click', (event) => {
        const trigger = event.target.closest('.video-thumbnail-trigger');
        const wrapper = trigger?.closest('[data-deferred-testimonial-video]');
        if (!trigger || !wrapper) return;
        event.preventDefault();
        openLightbox(trigger, wrapper);
      });
    });
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialiseDeferredVideos, { once: true });
  } else {
    initialiseDeferredVideos();
  }
})();
